import React from 'react';
import styled from 'styled-components';
import { Headline } from '@oneaudi/unified-web-components';
import { ContentContainer } from './content-container';
import { getOpacity } from '../utils/animations';
import { Headlines, ThemeScroll } from '../FeatureAppTypes';

const HeadlineContainer = styled.div<{ isStatic?: boolean }>`
  z-index: 2;
  ${({ isStatic }) => !isStatic && 'position: absolute; height: 100vh'};
  display: flex;
  align-items: center;
  sup {
    font-size: 0.4em;
    vertical-align: super;
  }
`;

export interface HeadlineProps {
  isStatic?: boolean;
  position?: number;
  headlines: Headlines;
  theme: ThemeScroll;
}

export const HeadlineComponent: React.FC<HeadlineProps> = ({
  isStatic = false,
  position = 0,
  headlines,
  theme,
}) => {
  // TODO: index can be editable via editor to have more flexibility
  const defaultIndex = 75;
  const opacity = getOpacity(position, defaultIndex);

  return headlines ? (
    <HeadlineContainer
      isStatic={isStatic}
      style={{
        opacity: `${opacity}`,
      }}
    >
      <ContentContainer theme={theme}>
        {headlines.map((item, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <Headline
            key={`headline-${item}`}
            data-testid={`headline-${idx}`}
            tag="h2"
            variant={{ type: 'display', order: '2', weight: 'normal' }}
          >
            {item}
          </Headline>
        ))}
      </ContentContainer>
    </HeadlineContainer>
  ) : null;
};
